import { render, staticRenderFns } from "./marketing-terms-modal.vue?vue&type=template&id=d36a25d4"
import script from "./marketing-terms-modal.vue?vue&type=script&lang=js"
export * from "./marketing-terms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports